export const istelist = [
    {
      id:1,
      point:'Providing quality training programmes to teachers and administrators of technical institutions to update their knowledge and skills in their fields of activity.'
    },
    {
      id:2,
      point:'To assist and contribute in the production and development of top quality professional engineers and technicians needed by the industry and other organisations.'
    },
    {
        id:3,
        point:'Providing guidance and training to students to develop better learning skills and personality.'
      }
  ]



export const istepdf=[
    {
        'id':"6",
        "head":"2021-2022",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1jKaN5RTIy3q9xfJ0cN7_wv9JKg51UtpZ/view?usp=sharing"
    },
    {
        'id':"1",
        "head":"2020-2021",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1kCVYuMu8ndMj4vsM_DiMliuUNEBEumDB/view?usp=sharing"
    },
    {
        'id':"2",
        "head":"2019-2020",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1z7RlZ317aKpgY3rD7Bjzywx6k-1MQL1M/view?usp=sharing"
    },
    {
        'id':"3",
        "head":"2018-2019",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1a1Xq-OJfPD5pNN68D60OuXQBXEAXixK0/view?usp=sharing"
    },
    {
        'id':"4",
        "head":"2017-2018",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1Z1_NdITaNtPKLayXHhJ-Yh18pQF6-4vl/view?usp=sharing"
    },
    {
        'id':"5",
        "head":"2016-2017",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1_eZfZCEg9f_lKUDZkxZqJ_2fsUsM8cPo/view?usp=sharing"
    }
]

export const iste_stud_chapter = [
    {
        'id':1,
        'program':"ISTE-TN156",
        'pdf':"https://drive.google.com/file/d/18-X2ZG01iWb_ueQyYqS90qP8d-afwQ9S/view?usp=sharing"
    }
]